import {
  getCategories,
  getFacet,
  getText,
  appendGOATandCountryCodeToTitle,
} from 'shared/utils/pageMetadataUtils';
import { t } from 'localization/utils/t';

const TP = 'shared.utils.getBrandParentMetadata';

export const getBrandParentMetadata = ({
  pageTitle,
  pageDescription,
  constructorResponse,
  locale,
}) => {
  const { groups = [], facets = [] } = constructorResponse?.response || {};
  const brandFacet = getFacet(facets, 'brand');
  const brandName: string = brandFacet?.options?.[0]?.display_name;
  const { topLevelCategories, subCategories } = getCategories(groups);

  // Pulling out static strings for translation purposes
  const including = t(`${TP}.including`, 'including');
  const includingTopLevelCategories = getText(including, topLevelCategories?.constructedList);

  const topThreeSubCategories = getText('', subCategories?.constructedList);
  const featuringACollectionOfTopThreeSubCategories =
    topThreeSubCategories?.length > 0
      ? t(
          `${TP}.featuringACollectionOfTopThreeSubCategories`,
          'Featuring a collection of {topThreeSubCategories}.',
          { topThreeSubCategories },
        )
      : '';

  const title = t(`${TP}.title`, 'Buy {brandName}: New and Seasonal Styles', {
    brandName,
  });
  const description = t(
    `${TP}.description`,
    'Shop {brandName} on GOAT {includingTopLevelCategories}. {featuringACollectionOfTopThreeSubCategories} Authenticity assured.',
    {
      brandName,
      includingTopLevelCategories,
      featuringACollectionOfTopThreeSubCategories,
    },
  );

  return {
    pageTitle: pageTitle || appendGOATandCountryCodeToTitle(title, locale),
    pageDescription: pageDescription || description,
  };
};
